<template>
  <li class="extras-mg-titulo">
    <span class="extras-mg-titulo__nombre">{{ table.name }}</span>
    <span v-if="database" class="extras-mg-titulo__base">{{
      database.name
    }}</span>
  </li>
</template>

<script>
/**
 * El nombre de la tabla en la barra superior.
 *
 * En Monday lo primero que se lee arriba es el nombre del tablero; en Baserow
 * ese nombre solo vive en la barra lateral y la cabecera empieza por el
 * selector de vista. Esto lo trae al frente, que es la diferencia mas grande
 * que quedaba entre las dos pantallas.
 *
 * Se cuelga de getAdditionalTableHeaderComponents(), un punto de extension del
 * core que pinta cada componente como un <li> de la misma lista. El core lo
 * inserta despues del selector de vista, asi que la piel lo manda al principio
 * con `order: -1` en vez de tocar el orden del core.
 *
 * Es solo texto a proposito: renombrar ya se hace desde la barra lateral y un
 * segundo sitio para lo mismo es un sitio mas donde equivocarse.
 */
export default {
  name: 'TituloDeTabla',
  props: {
    database: { type: Object, required: false, default: null },
    table: { type: Object, required: true },
    view: { type: Object, required: false, default: null },
    fields: { type: Array, required: false, default: () => [] },
    isPublicView: { type: Boolean, required: false, default: false },
    storePrefix: { type: String, required: false, default: '' },
  },
}
</script>
